'use client';

import { useCallback } from 'react';
import type { Country } from '../../constants';
import { useGetShippingPolicy } from './useGetShippingPolicy';

export const useGetAmountToFreeShipping = (country: Country) => {
  const { shippingPolicy } = useGetShippingPolicy(country);

  const getAmountToFreeShipping = useCallback(
    (currentPrice: number) => {
      const freeShippingThreshold = shippingPolicy?.freeShippingThreshold ?? 0;

      const amountPrice = freeShippingThreshold - currentPrice;

      if (amountPrice > 0) {
        return amountPrice;
      }
      return 0;
    },
    [shippingPolicy],
  );

  return { getAmountToFreeShipping };
};
